<template>
  <v-dialog :model-value="isOpen" width="732" v-on:keydown.stop>
    <template v-slot:activator="{ props }">
      <slot name="activator" :props="props"></slot>
    </template>

    <div class="dialog">
      <div class="d-flex mb-6">
        <span class="text-title mr-3 mt-3 text-truncate">Canceling plan? This is what happens</span>
        <v-spacer/>
        <v-btn variant="text" color="grey" @click="close" icon="mdi-close">
        </v-btn>
      </div>

      <div class="d-flex flex-column ga-8 mb-6">
        <div class="dialog-text-container">
          <div class="dialog-text-title">
            Current Plan
          </div>
          <div class="dialog-text-description">
            You're subscribed to Qlerify {{ selectedPlan?.name }} at
            ${{ selectedSubscriptionType === 'monthly' ? selectedPlan?.monthlyPrice : selectedPlan?.yearlyPrice }}
            per user per {{ selectedSubscriptionType === 'monthly' ? 'month' : 'year' }} for
            {{ activeSubscription?.subscriptionDetails?.quantity }} user(s).
          </div>
        </div>

        <div class="dialog-text-container">
          <div class="dialog-text-title">
            Next Payment Date
          </div>
          <div class="dialog-text-description">
            Your next payment of ${{
              (selectedSubscriptionType === 'monthly' ? selectedPlan?.monthlyPrice : selectedPlan?.yearlyPrice) * subscriptionUsers.length
            }} is scheduled for {{ nextBillingDate }}. Canceling now means you won’t be charged.
          </div>
        </div>

        <div class="dialog-text-container">
          <div class="dialog-text-title">
            Subscription Access
          </div>
          <div class="dialog-text-description">
            If you cancel now, you'll still have full access to Qlerify {{ selectedPlan?.name }} benefits until {{
              nextBillingDate
            }}.
          </div>
        </div>

        <div class="dialog-text-container">
          <div class="dialog-text-title">
            Data Retention
          </div>
          <div class="dialog-text-description">
            Your data will be kept for 6 months after cancellation. If you'd like to delete it immediately, <a
              target="_blank"
              href="https://webforms.pipedrive.com/f/6NfI0XGDzXIe8nGmpN1ly8pQUw2YUXE6GnPVoWuCyliiWcg13YOiNmQBCeX3PF6nbJ">
              contact us here</a>.
          </div>
        </div>

        <div class="dialog-text-container">
          <div class="dialog-text-title">
            Account & Projects
          </div>
          <div class="dialog-text-description">
            After {{ nextBillingDate }}, you and all users on your plan will lose access to projects and workflows.
          </div>
        </div>
      </div>

      <div class="d-flex ga-2">
        <v-spacer/>
        <v-btn
          size="large"
          variant="flat"
          :disabled="loadingCancelSubscription"
          @click="onChangeSubscription"
        >
          Change Plan
        </v-btn>
        <v-btn
          size="large"
          variant='outlined'
          color="var(--red-1)"
          :loading="loadingCancelSubscription"
          @click="onCancelSubscription"
        >
          Cancel my subscription
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import store from '@/store'
import format from 'date-fns/format'
import { mapState } from 'vuex'
import { getPlanByPriceId, getSubscriptionTypeByPriceId } from '@/utils/payments'

export default {
  name: 'cancel-subscription-dialog',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapState({
      activeSubscription: state => state.payments.activeSubscription,
      subscriptionUsers: state => state.payments.subscriptionUsers,
      subscriptionAccessType: state => state.payments.subscriptionAccessType,
      loadingCancelSubscription: state => state.payments.loadingCancelSubscription
    }),
    selectedPlan: function () {
      if (this.activeSubscription) {
        return getPlanByPriceId(this.activeSubscription?.subscriptionDetails?.price?.id)
      }
      return null
    },
    selectedSubscriptionType: function () {
      if (this.activeSubscription) {
        const priceId = this.activeSubscription?.subscriptionDetails?.price?.id || this.activeSubscription?.lastSubscriptionDetails?.price?.id
        return getSubscriptionTypeByPriceId(priceId)
      }
      return null
    },
    nextBillingDate: function () {
      if (this.activeSubscription?.subscriptionDetails?.nextBillingDate) {
        return format(new Date(this.activeSubscription?.subscriptionDetails?.nextBillingDate), 'MMMM dd, yyyy')
      }
      return ''
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async onCancelSubscription () {
      const data = await store.dispatch('payments/cancelSubscription')
      if (data.success) {
        this.$emit('onCancel')
      }
    },
    async onChangeSubscription () {
      this.$emit('onChangeSubscription')
    }
  }
}
</script>

<style scoped>
.dialog {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #FCFCFC;
  background: #FCFCFC;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
}

.dialog-text-container {
  gap: 8px;
  display: flex;
  flex-direction: column;

  .dialog-text-title {
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    color: var(--dark-4, #363A40);
  }

  .dialog-text-description {
    font-size: 16px;
    font-weight: 300;
    line-height: 22.4px;
    color: #000000;
  }
}
</style>
